const site = {
  slug: 'minimural-nails', brand: 'MINI MURAL', domain: 'minimuralnails.com',
  locale: 'en-US', currency: 'USD', apiBase: '/api', preview: true,
  checkoutEnabled: false,
  paymentSequence: ['design', 'review', 'payment', 'production', 'shipment'],
  supportEmail: '', marketConfirmed:false,
};
export default site;
